import EnrichmentIcon from "assets/icons/EnrichmentIcon";
import classNames from "classnames";
import styles from "./style.module.scss";
import { RefObject } from "react";
import teaserBGImage from "assets/pngImages/enrichment-teaser.png";

interface EnrichmentTeaserboxTypes {
  vlEnrichmentRef: RefObject<HTMLDivElement>;
}

const EnrichmentTeaser = ({ vlEnrichmentRef }: EnrichmentTeaserboxTypes) => {
  const teaserMessage =
    "Ask the Dataset owner to enrich this Dataset with proprietary or foundation AI models";
  return (
    <div className={styles.enrichmentTeaser} ref={vlEnrichmentRef}>
      <div className={styles.teaserBGImage}>
        <img src={teaserBGImage} alt="Enrichment Teaser" />
      </div>
      <div className={styles.container}>
        <div className={styles.TitleContainer}>
          <div className={styles.titleIcon}>
            <EnrichmentIcon />
          </div>
          <div className={styles.titleText}>Enrichment Models</div>
        </div>
        <div className={styles.body}>
          <div
            className={classNames(styles.messageContainer, styles.extraMargin)}
          >
            {teaserMessage}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrichmentTeaser;
